"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_interchangable__batteries__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ea6aea27-2816-4bf5-9439-33e1d7ab192b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f5166916-728c-43a8-903e-6627e1b52ec4{fill:url(#a630c348-1f09-4c3c-b012-9a0dde98e1b9);}.f429096d-16af-44af-b700-c0a4e8f612e5{fill:#f4f4f4;}.a3f0420a-2815-41dc-a6a2-18577d41de91{opacity:0.06;isolation:isolate;}.bef375e6-3c24-4019-b948-f23a7cf9eda0,.ff6b37bb-91ad-41da-b69e-b7fa32e3b2ce{fill:none;}.bef375e6-3c24-4019-b948-f23a7cf9eda0{stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:8px;}.f151e2da-8f5f-4d9a-9e5d-e19eff1d7ec9{fill:url(#a24e403e-1e44-42e5-b001-b7a968cea1c1);}.b64e89b2-46dc-4bca-b7b7-e671606f4a48{fill:url(#ad21d323-94bc-43d6-b9bf-2829fab688f0);}.b162b730-6615-4bc8-80ba-c73e03033df0{fill:#fff;}.a8153c43-fc5e-4fd9-a22a-e235fb470248{fill:#666;}.ee7d394d-7885-4327-8e76-81dc004eeaa8{fill:#e60000;}.fec3cff8-8110-4123-85f4-175ce1ebfc36{opacity:0.12;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a630c348-1f09-4c3c-b012-9a0dde98e1b9",
    x1: 100,
    y1: 161.07,
    x2: 132.1,
    y2: 161.07,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 192.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdbdbd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a24e403e-1e44-42e5-b001-b7a968cea1c1",
    x1: 106.08,
    y1: 129.6,
    x2: 106.08,
    y2: 129.6,
    xlinkHref: "#a630c348-1f09-4c3c-b012-9a0dde98e1b9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad21d323-94bc-43d6-b9bf-2829fab688f0",
    x1: 60,
    y1: 145.07,
    x2: 92.07,
    y2: 145.07,
    xlinkHref: "#a630c348-1f09-4c3c-b012-9a0dde98e1b9"
  })), /*#__PURE__*/React.createElement("title", null, "interchangable-batteries-hi-dark"), /*#__PURE__*/React.createElement("path", {
    className: "f5166916-728c-43a8-903e-6627e1b52ec4",
    d: "M132.1,40V30.3a6.58,6.58,0,0,0-6.57-6.58h-19A6.59,6.59,0,0,0,100,30.3V40Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f429096d-16af-44af-b700-c0a4e8f612e5",
    d: "M132.1,40V30.3a6.58,6.58,0,0,0-6.57-6.58h-19A6.59,6.59,0,0,0,100,30.3V40Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3f0420a-2815-41dc-a6a2-18577d41de91",
    d: "M125.53,23.72h-19A6.59,6.59,0,0,0,100,30.3v2a6.59,6.59,0,0,1,6.53-6.58h19a6.58,6.58,0,0,1,6.57,6.58v-2A6.58,6.58,0,0,0,125.53,23.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bef375e6-3c24-4019-b948-f23a7cf9eda0",
    d: "M168.08,21.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bef375e6-3c24-4019-b948-f23a7cf9eda0",
    d: "M168.08,21.51",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ff6b37bb-91ad-41da-b69e-b7fa32e3b2ce",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "f151e2da-8f5f-4d9a-9e5d-e19eff1d7ec9",
    d: "M106.08,63.33",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f429096d-16af-44af-b700-c0a4e8f612e5",
    d: "M86,39.72h52.17A9.86,9.86,0,0,1,148,49.59V142a9.85,9.85,0,0,1-9.86,9.86H108.06",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3f0420a-2815-41dc-a6a2-18577d41de91",
    d: "M108.06,151.86h30.08A9.85,9.85,0,0,0,148,142v-2a9.85,9.85,0,0,1-9.86,9.86H108.06Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3f0420a-2815-41dc-a6a2-18577d41de91",
    d: "M138.17,39.72H86l.39,2h51.78A9.86,9.86,0,0,1,148,51.59v-2A9.86,9.86,0,0,0,138.17,39.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b64e89b2-46dc-4bca-b7b7-e671606f4a48",
    d: "M92.07,56V46.3a6.6,6.6,0,0,0-6.58-6.58H66.54A6.58,6.58,0,0,0,60,46.3V56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b162b730-6615-4bc8-80ba-c73e03033df0",
    d: "M92.07,56V46.3a6.6,6.6,0,0,0-6.58-6.58H66.54A6.58,6.58,0,0,0,60,46.3V56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3f0420a-2815-41dc-a6a2-18577d41de91",
    d: "M85.49,39.72H66.54A6.58,6.58,0,0,0,60,46.3v2a6.58,6.58,0,0,1,6.54-6.58H85.49a6.6,6.6,0,0,1,6.58,6.58v-2A6.6,6.6,0,0,0,85.49,39.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b162b730-6615-4bc8-80ba-c73e03033df0",
    d: "M108.06,142.64v15.5A9.85,9.85,0,0,1,98.2,168H53.8a9.85,9.85,0,0,1-9.86-9.86h0V65.6a9.85,9.85,0,0,1,9.86-9.86H98.2a9.85,9.85,0,0,1,9.86,9.86h0v77Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b162b730-6615-4bc8-80ba-c73e03033df0",
    d: "M108.06,142.64v15.5A9.85,9.85,0,0,1,98.2,168H53.8a9.85,9.85,0,0,1-9.86-9.86h0V65.6a9.85,9.85,0,0,1,9.86-9.86H98.2a9.85,9.85,0,0,1,9.86,9.86h0v77Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3f0420a-2815-41dc-a6a2-18577d41de91",
    d: "M98.2,55.74H53.8a9.85,9.85,0,0,0-9.86,9.86v2a9.85,9.85,0,0,1,9.86-9.86H98.2a9.85,9.85,0,0,1,9.86,9.86v-2A9.85,9.85,0,0,0,98.2,55.74Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a3f0420a-2815-41dc-a6a2-18577d41de91",
    d: "M98.2,166H53.8a9.85,9.85,0,0,1-9.86-9.86v2A9.85,9.85,0,0,0,53.8,168H98.2a9.85,9.85,0,0,0,9.86-9.86v-2A9.85,9.85,0,0,1,98.2,166Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8153c43-fc5e-4fd9-a22a-e235fb470248",
    d: "M67.94,77.72h6v6a2,2,0,0,0,4,0v-6h6a2,2,0,0,0,0-4h-6v-6a2,2,0,0,0-4,0v6h-6a2,2,0,0,0,0,4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8153c43-fc5e-4fd9-a22a-e235fb470248",
    d: "M83.94,149.72h-16a2,2,0,0,0,0,4h16a2,2,0,0,0,0-4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ee7d394d-7885-4327-8e76-81dc004eeaa8",
    d: "M128.19,101.63h0a2,2,0,0,0-2,2,24.1,24.1,0,0,1-24.07,24h0a24.1,24.1,0,0,1-24-24.07v-7l8.74,8.77a2,2,0,0,0,1.44.59,2,2,0,0,0,1.43-3.45L77.42,90.3h0a1.42,1.42,0,0,0-.3-.25L77,90l-.21-.11-.19-.06-.19-.06h-.8l-.22.07h-.16L75,90l-.15.09a1,1,0,0,0-.2.16l-.11.08-12,12a2,2,0,1,0,2.87,2.87L74,96.62v7a28.16,28.16,0,0,0,28.09,28.12h0a28.15,28.15,0,0,0,28.12-28.09,2,2,0,0,0-2-2Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "fec3cff8-8110-4123-85f4-175ce1ebfc36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.18,104.27a2,2,0,0,1-1.43-.6L78,94.91v1.72l8.74,8.77A2,2,0,0,0,90,103.1a2.22,2.22,0,0,1-.39.57A2,2,0,0,1,88.18,104.27Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.37,103.48a2,2,0,0,1-2.83,0l0,0a2.22,2.22,0,0,1-.39-.57,2,2,0,0,0,3.26,2.3L74,96.62V94.89Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.08,130h0A28.15,28.15,0,0,1,74,101.9v1.73a28.17,28.17,0,0,0,28.09,28.12h0a28.17,28.17,0,0,0,28.13-28.09,2.16,2.16,0,0,0,0-.36A28.16,28.16,0,0,1,102.08,130Z",
    transform: "translate(0 0)"
  })));
}

var _default = ic_interchangable__batteries__dark;
exports.default = _default;